import { IcebergIcon } from '@tradesolution/iceberg-ui-react';
import { CompareStatus, qaCompareSimpleValue } from 'pages/QA/components/QACardDetails/utils';
import { useEffect, useState } from 'react';
import CompareIcon from '../../../CompareIcon';
import Style from '../../index.module.css';
import { Button, Collapse, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { ChangeRequestValidator } from 'pages/QA/components/QACardDetails/ChangeRequestValidator';
import CopyToClipboardIcon from 'components/CopyToClipboardIcon';

interface Props {
  value: number | undefined;
  onChange: (value: string) => void;
  changeRequest: {
    salgsareal: number;
    salgsarealFromCr: number;
  };
  error?: string;
}

const SalgsarealRow = (props: Props) => {
  const [isExpandRow, setIsExpandRow] = useState<boolean>(false);
  const [compareStatus, setCompareStatus] = useState<CompareStatus>(
    qaCompareSimpleValue(props.changeRequest.salgsareal?.toString(), props.value?.toString()),
  );
  const [crValueError, setCrValueError] = useState<string | null>(null);

  const handleExpandRowClick = () => {
    setIsExpandRow(!isExpandRow);
  };

  const transferSalgsareal = (salgsareal: number) => {
    if (props.value !== salgsareal) {
      props.onChange(salgsareal?.toString());
    }
  };

  // Automatically expand the accordion if the values are not alike
  useEffect(() => {
    if (compareStatus === 'ulik' || compareStatus === 'ny') {
      setIsExpandRow(true);
    } else {
      setIsExpandRow(false);
    }
  }, [compareStatus]);

  useEffect(() => {
    setCompareStatus(
      qaCompareSimpleValue(props.changeRequest.salgsareal?.toString(), props.value?.toString()),
    );
  }, [props.value, props.changeRequest.salgsareal]);

  // Check if the value from the change request has any errors
  useEffect(() => {
    if (props.changeRequest.salgsarealFromCr) {
      const error = ChangeRequestValidator.hasSalgsarealErrors(
        props.changeRequest.salgsarealFromCr,
      );
      setCrValueError(error);
    } else {
      setCrValueError(null);
    }
  }, [props.changeRequest.salgsarealFromCr]);

  return (
    <>
      <div className={Style.changeRequestRowHeaderContainer} onClick={handleExpandRowClick}>
        <h6 className={Style.changeRequestRowHeader}>
          {!isExpandRow && <CompareIcon compareStatus={compareStatus} size="sm" />}
          <span className={Style.changeRequestRowHeaderText}>Salgsareal</span>
        </h6>
        <Button variant="link" size="sm">
          <IcebergIcon icon={isExpandRow ? 'chevron-up' : 'chevron-down'} bold />
        </Button>
      </div>
      <Collapse in={isExpandRow}>
        <div>
          <Row className={Style.formGroupRow}>
            <Col xs={12} md={5}>
              <Form.Group className={Style.formGroup}>
                <InputGroup size="sm" className={Style.inputGroup}>
                  <Form.Control
                    value={props.changeRequest.salgsareal ?? ''}
                    readOnly
                    isValid={!crValueError && !!props.changeRequest.salgsarealFromCr}
                    isInvalid={!!crValueError}
                  />
                  <InputGroup.Text>
                    <CopyToClipboardIcon val={props.changeRequest.salgsarealFromCr} />
                  </InputGroup.Text>
                  <Form.Control.Feedback type="invalid">
                    {crValueError ?? 'Salgsareal er ugyldig.'}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs="auto" md={2} className={Style.compareIconContainer}>
              {!!crValueError ? (
                <CompareIcon compareStatus="ugyldig" tooltipText={crValueError} />
              ) : (
                <CompareIcon
                  compareStatus={compareStatus}
                  onClick={() => transferSalgsareal(props.changeRequest.salgsareal)}
                />
              )}
            </Col>
            <Col xs={12} md={5}>
              <Form.Group className={Style.formGroup}>
                <InputGroup size="sm" className={Style.inputGroup}>
                  <Form.Control
                    type="text"
                    value={props.value ?? ''}
                    onChange={(e) => props.onChange(e.target.value.trim())}
                  />
                </InputGroup>
                {props.error && <Form.Text className="text-danger">{props.error}</Form.Text>}
              </Form.Group>
            </Col>
          </Row>
        </div>
      </Collapse>
    </>
  );
};
export default SalgsarealRow;
